import React, { useCallback, useRef } from 'react';
import { useOnClickOutside } from '../../../../core/helpers/useOutSideClick';
import {
  randomTicketNumbersGeneratorCount,
  randomTicketNumbersGeneratorCountKeno8,
} from '../../../../core/constants/gameConstants';

function TicketNumberCountSlider({
  setIsOpenTicketNumbersCountSlider,
  setNumbersCountInTicket,
  isKeno8,
}) {
  const containerRef = useRef();

  useOnClickOutside(
    containerRef,
    (e) => {
      e.stopPropagation();
      setIsOpenTicketNumbersCountSlider(false);
    },
    true
  );

  const handleSelectTicketCount = useCallback(
    (ticketCount) => {
      setNumbersCountInTicket(ticketCount);
      setIsOpenTicketNumbersCountSlider(false);
    },
    [setNumbersCountInTicket, setIsOpenTicketNumbersCountSlider]
  );

  return (
    <div className='keno-tickets-number-block' ref={containerRef}>
      <div className='keno-tickets-number-list'>
        {(isKeno8 ? randomTicketNumbersGeneratorCountKeno8 : randomTicketNumbersGeneratorCount).map(
          (el) => {
            return (
              <div
                className='keno-tickets-number-item'
                key={el}
                onClick={() => handleSelectTicketCount(el)}
              >
                <span className='keno-tickets-number'>{el}</span>
              </div>
            );
          }
        )}
      </div>
    </div>
  );
}
export default TicketNumberCountSlider;
